export default __webpack_public_path__ + "static/media/image.b17f9956.svg";